import { API, graphqlOperation } from 'aws-amplify';
import { createLicenceMaintenanceHistory } from './mutations';

export async function addMaintenanceHistory({
  licenceId,
  userId,
  owner,
  beforePeriod,
  afterPeriod,
  beforeSubscriptionExpiryDateAt,
  afterSubscriptionExpiryDateAt,
  beforeMaintenancePeriod,
  afterMaintenancePeriod,
  reason = '',
}) {
  const input = {
    licenceId,
    userId,
    owner,
    reason,
    beforePeriod,
    afterPeriod,
    beforeSubscriptionExpiryDateAt,
    afterSubscriptionExpiryDateAt,
    beforeMaintenancePeriod,
    afterMaintenancePeriod,
  };

  const res = await API.graphql(
    graphqlOperation(createLicenceMaintenanceHistory, { input })
  );

  return res.data.createLicenceMaintenanceHistory;
}
